import { render, staticRenderFns } from "./agentData.vue?vue&type=template&id=6061f47c&scoped=true"
import script from "./agentData.vue?vue&type=script&lang=js"
export * from "./agentData.vue?vue&type=script&lang=js"
import style0 from "./agentData.vue?vue&type=style&index=0&id=6061f47c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6061f47c",
  null
  
)

export default component.exports